import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PageData, PageDataStatus, FetchStateType } from "../../models";
import { DividendList, DividendData } from "./types";

type DividendsData = {
	currentPage?: PageData<DividendList>;
	displayDividend?: DividendData;
	cancelFetchState: FetchStateType;
	printDividendFetchState: FetchStateType;
	downloadXlsFetchState: FetchStateType;
};

const initialState: DividendsData = {
	cancelFetchState: { type: "not-started" },
	printDividendFetchState: { type: "not-started" },
	downloadXlsFetchState: { type: "not-started" },
};

const name = "dividends";

const dividendsSlice = createSlice({
	name,
	initialState,
	reducers: {
		setDividends: (state, action: PayloadAction<PageData<DividendList>>) => ({
			...state,
			currentPage: action.payload,
		}),
		setDisplayed: (state, action: PayloadAction<DividendData | undefined>) => ({
			...state,
			displayDividend: action.payload,
		}),
		invalidateDividends: state => {
			if (!state.currentPage) return state;

			return {
				...state,
				currentPage: {
					...state.currentPage,
					status: PageDataStatus.DataInvalidated,
				},
			};
		},
		setCancelDividnedsFetchState: (state, action: PayloadAction<FetchStateType>) => ({
			...state,
			cancelFetchState: action.payload,
		}),
		setPrintDividendsFetchState: (state, action: PayloadAction<FetchStateType>) => ({
			...state,
			printDividendFetchState: action.payload,
		}),
		setDownloadXlsFetchState: (state, action: PayloadAction<FetchStateType>) => ({
			...state,
			downloadXlsFetchState: action.payload,
		}),
	},
});

export const { setDividends, setDisplayed, invalidateDividends, setCancelDividnedsFetchState, setPrintDividendsFetchState,setDownloadXlsFetchState,
} = dividendsSlice.actions;

export default dividendsSlice.reducer;
